export default __webpack_public_path__ + "static/media/img-3.0446ebc4.jpg";